<template>
  <div class="page-wrapper">
    <div class="container-fluid h-100">
      <div class="row h-100">
        <div class="col-6 h-100 vertical-scroll text-left" style="position:relative;padding-bottom:100px; background-color: white;">
          <div style="display: flex; height:50px; padding:10px 0px 0px 30px; position: sticky; top:0;background-color: white;margin-left: -15px;margin-right: -15px;">
            <span style="line-height: 30px;"><strong>Type: </strong></span>
            <select v-model="merchantType" style="height: 30px;">
              <option value="all">All</option>
              <option value="kokoro">KOKORO</option>
              <option value="jv">JV</option>
              <option value="franchise">FRANCHISE</option>
              <option value="premier">PREMIER</option>
              <option value="vendor">VENDOR</option>
              <option value="personal">PERSONAL</option>
            </select>

            <span style="line-height: 30px; margin-left: 50px;">Search:</span> <input v-model="merchantSearch" class="text-input-field"/>
          </div>
          <table class="table text-left">
            <tr style="">
              <th style="position:sticky;top:50px;background-color: white;">Title</th>
              <th style="position:sticky;top:50px;background-color: white;">Type</th>
              <th style="position:sticky;top:50px;background-color: white;">Contact</th>
              <th style="position:sticky;top:50px;background-color: white;">After Cutoff</th>
              <th style="position:sticky;top:50px;background-color: white; text-align: right;">Balance <span v-html="getTotalBalance()"></span></th>

            </tr>
            <tbody >
              <template v-for="m in merchants">
                <tr class="hover-item"

                    v-if="(merchantType === 'all' || merchantType === m.type) && (merchantSearch === '' || m.title.toLowerCase().includes(merchantSearch.toLowerCase()))"
                    v-on:click="openItem(m)"
                    v-bind:class="{'row-item-selected': editItem != false && m.id ==editItem.id, 'deactive': m.active === false}">
                  <td>{{m.title}}<span v-if="m.active === false"> (Inactive)</span></td>
                  <td style="text-transform: uppercase;">{{m.type}}</td>
                  <td>{{m.contactName}}</td>
                  <td><span style="color: red; font-weight: bold;" v-if="m.blockOrderAfterCutOff === true">Block</span><span v-else>Allow</span></td>
                  <td class="text-right">{{(m.accountBalance/100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",")}}</td>

                </tr>
              </template>
            </tbody>
          </table>
        </div>
        <div class="col-6 h-100 vertical-scroll">
          <transition name="slide">
            <div class="container info-panel" v-if="editItem !== false">
<!--              <div class="row">-->
<!--                <div class="col-12 text-right">-->
<!--                  <button class="btn btn-primary" v-on:click="saveItem"><i class="fas fa-save"></i> 저장</button>-->
<!--                  <span><i class="fas fa-trash"></i></span>-->
<!--                  <span><i class="fas fa-edit"></i></span>-->
<!--                </div>-->
<!--              </div>-->
              <div class="row" v-if="editItem.edit === undefined || editItem.edit === false">
                <div class="col-12">
                  <div class="card" >
                    <div class="card-header text-left" style="line-height: 40px; font-size: 25px; font-weight: bold;">
                      {{editItem.title}} [{{editItem.type.toUpperCase()}}] <button v-if="user !== false && user.manageShopAccount === true" class="btn btn-primary" style="float:right;" v-on:click="editMerchantItem"><i class="fas fa-edit"></i> EDIT</button>
                    </div>
                    <div class="card-body text-left">
                      Company Name: {{editItem.companyName}}
                      <br>Company Number: {{editItem.companyNumber}}
                      <br>VAT:{{editItem.vatNumber}}
                      <br>
                      Addresss: {{editItem.postCode}} {{editItem.address}}
                      <br>Contact Point: {{editItem.contactName}}<br>Phone: {{editItem.contact}}
                      <br>
                      <template v-if="editItem.emails != null && editItem.emails.length > 0">
                        EMAILS: <span v-for="(e, i) in editItem.emails"><span v-if="i > 0">,</span>{{e}}</span>
                      </template>
                      <br>
                      <template v-if="editItem.ccEmails != null && editItem.ccEmails.length > 0">
                        CC EMAILS: <span v-for="(e, i) in editItem.ccEmails"><span v-if="i > 0">,</span>{{e}}</span>
                      </template>
                      <br/>

<!--                      <span v-if="editItem.blockOrderAfterCutOff === true" style="color:red; font-weight: bold;">After cutoff  BLOCK orders until 8AM or as defined in delivery schedule</span>-->
                      <br/>
                      <span v-if="editItem.defaultDriverId > 0">Default Driver : {{getDriverName(editItem.defaultDriverId)}} <br/></span>
                      <span v-if="editItem.defaultDeliveryShift > 0">Default Delivery : {{getShiftName(editItem.defaultDeliveryShift)}} <br/></span>
                      <span v-if="editItem.id > 0">Merchant ID: {{editItem.id}}</span>
                      <br/>
                      <br/>
                      <div style="font-weight: bold; font-size: 20px;">
                      Order After Cutoff time: <span style="color:red;" v-if="editItem.blockOrderAfterCutOff === true">Block</span><span v-else>Allow</span>
                      </div>
                      <br/>
                      <div style="font-weight: bold; font-size: 18px;">
                        <span v-for="tag in editItem.tags">#{{tag}}</span>
                      </div>
                      <br/>
                      <button class="btn btn-primary" v-if="user !== false && user.manageShopAccount === true && editItem.guacEnabled === false"  @click="enableApi(editItem, true)">Enable Guac API</button>
                      <div v-if="editItem.guacEnabled === true">
                        <div>GUAC API KEY <button class="btn" @click="enableApi(editItem, false)">Disable API</button></div>
                        <div style="padding:10px; border: 1px solid #e4e4e4;">
                          {{editItem.apiKey}}
                        </div>
                      </div>

                    </div>
                  </div>
                </div>
              </div>
              <div class="row text-left input-row" v-if="editItem.edit !== undefined && editItem.edit == true">
                <div class="col-12">
                  <label>Title</label>
                  <input type="text" class="form-control" v-model="editItem.title" placeholder="Title"/>
                </div>
                <div class="col-12">
                  <label>Type</label>
                  <select class="form-control" v-model="editItem.type">
                    <option value="kokoro">KOKORO</option>
                    <option value="jv">JV</option>
                    <option value="franchise">FRANCHISE</option>
                    <option value="premier">PREMIER</option>
                    <option value="vendor">VENDOR</option>
                    <option value="personal">PERSONAL</option>
                  </select>
                </div>

                <div class="col-12">
                  <label>Company Name</label>
                  <input type="text" class="form-control" v-model="editItem.companyName" placeholder="Company Name"/>
                </div>
                <div class="col-12">
                  <label>Post Code</label>
                  <input type="text" class="form-control" v-model="editItem.postCode" placeholder="POST CODE"/>
                </div>
                <div class="col-12">
                  <label>Address</label>
                  <input type="text" rows=3 class="form-control" v-model="editItem.address" placeholder="Address"/>
                </div>
                <div class="col-12">
                  <label>Company Number</label>
                  <input type="text" class="form-control" v-model="editItem.companyNumber" placeholder="Company Number"/>
                </div>
                <div class="col-12">
                  <label>VAT Number</label>
                  <input type="text" class="form-control" v-model="editItem.vatNumber" placeholder="VAT No"/>
                </div>
                <div class="col-12">
                  <label>Responsible</label>
                  <input type="text" class="form-control" v-model="editItem.contactName" placeholder="Contact Name"/>
                </div>
                <div class="col-12">
                  <label>Contact</label>
                  <input type="text" class="form-control" v-model="editItem.contact" placeholder="Contact"/>
                </div>
                <div class="col-12" style="display:none;">
                  <label>Email</label>
                  <input type="text" class="form-control" v-model="editItem.email" placeholder="Email"/>
                </div>
                <div class="col-12">
                  <label>Emails</label>
                  <input-tag type="text" class="form-control" v-model="editItem.emails" placeholder="Emails"/>
                </div>
                <div class="col-12">
                  <label>CC Emails</label>
                  <input-tag type="text" class="form-control" v-model="editItem.ccEmails" placeholder="CC Emails"/>
                </div>
                <div class="col-12">
                  <label>Default Driver</label>
                  <select v-model="editItem.defaultDriverId" class="form-control">
                    <option value="0">No driver</option>
                    <option v-for="d in drivers" :key="'driver-selector-'+d.id" :value="d.id">{{d.name}}</option>
                  </select>
                </div>
                <div class="col-12">
                  <label>Default Delivery Shift</label>
                  <select v-model="editItem.defaultDeliveryShift" class="form-control">
<!--                    <option value="0">No Preference</option>-->
                    <option v-for="s in shiftList" :key="'shift-selector-'+s.value" :value="s.value">{{s.title}}</option>
                  </select>
                </div>
                <div class="col-12">
                  <label>Order after cutoff</label>
                  <div class="form-control" style="padding-top:0; padding-left: 0;">
                  <button class="btn" v-bind:class="{'btn-danger':editItem.blockOrderAfterCutOff === true}" @click="editItem.blockOrderAfterCutOff = true">Block</button>
                  <button class="btn" style="margin-left: 10px;" v-bind:class="{'btn-dark':editItem.blockOrderAfterCutOff === false}" @click="editItem.blockOrderAfterCutOff = false">Allow</button>
                  </div>
                </div>


                <div class="col-12">
                  <label>TAGS</label>
                  <input-tag type="text" class="form-control" v-model="editItem.tags" placeholder="TAGs"/>
                </div>
              </div>
              <div class="row" style="padding-top: 20px;">
                <div class="col-4 text-left">
                  <button v-if="editItem.edit !== undefined && editItem.edit === true" class="btn btn-dark" v-on:click="cancelEditMerchant">Cancel</button>
                </div>
                <div class="col-4" v-if="user !== false && user.manageShopAccount === true">
                  <button class="btn btn-danger" v-if="editItem.active === true" v-on:click="askDeleteMerchant(editItem)">Deactivate</button>
                  <button class="btn btn-dark" v-if="editItem.active === false" >Inactive</button>
                </div>
                <div class="col-4 text-right">
                   <button v-if="editItem.edit !== undefined && editItem.edit === true" class="btn btn-primary" style="margin-left:20px;" v-on:click="saveItem"><i class="fas fa-save"></i> Save</button>
                </div>
              </div>

              <div class="row" v-if="user !== false && user.manageShopAccount === true">
                <div class="col-12 text-left section-header">
                  <button class="btn btn-primary" v-on:click="openAccounts">View Account</button>

                  <button class="btn btn-danger" v-on:click="openUnpaidList(editItem)">View Unpaid</button>

                  <button class="btn btn-success" style="margin-left: 30px;" v-on:click="openMerchantProductView(editItem)">Products</button>
                </div>
              </div>
              <div class="row">
                <div class="col-12 section-header">
                  <span><img src="/static/img/delivery_schedule.svg" height="50px;"/></span> Delivery Schedule
                </div>
              </div>
              <div class="row" v-if="editItem.deliveryDates != undefined && editItem.deliveryDates.length > 0">
                <div class="col-12">
                  <table class="table">
                    <tr>
                      <th></th>
                      <th>Delivery Day</th>
                      <th>Cut-off day</th>
                      <th>Time</th>
                      <th>Reopen</th>
                      <th style="display: none;">Need to order</th>
                    </tr>
                    <tbody>
                    <tr v-for="(date, di) in editItem.deliveryDates" v-bind:class="{'row-selected': date.selected == true}">
                      <td v-on:click="checkDeliveryDay(di, 'selected')" style="font-size: 1.5em;">
                        <span v-if="date.selected" style="color:green;"><i class="fas fa-check-square"></i></span>
                        <span v-else style="color:grey;"><i class="far fa-check-square"></i></span>
                      </td>
                      <td>{{getDayString(date.deliveryDay)}}</td>
                      <td>
                        <select v-model="date.cutOffDay" class="form-control" v-on:change="updateDeliveryDateItem(di)" :disabled="!date.selected || user === false || user.manageShopAccount === false">
                          <option v-for="(n, i) in 7" :value="i">{{getDayString(i)}}</option>
                        </select>
                      </td>
                      <td>
                        <select v-model="date.cutOffTimeHour" class="form-control" v-on:change="updateDeliveryDateItem(di)" :disabled="!date.selected || user === false || user.manageShopAccount === false">
                          <option v-for="(n, i) in 24" :value="i">{{pad(i, 2) + ':00'}}</option>
                        </select>
                      </td>

                      <td>
                        <select v-model="date.reopenHour" class="form-control" v-on:change="updateDeliveryDateItem(di)" :disabled="!date.selected || user === false || user.manageShopAccount === false">
                          <option value="-1">No Use or 8AM as default</option>
                          <option v-for="(n, i) in 24" :value="i">{{pad(i, 2) + ':00'}}</option>
                        </select>
                      </td>

                      <td v-on:click="checkDeliveryDay(di, 'needToOrder')" style="font-size: 1.5em;display: none;">
                        <span v-if="date.needToOrder" style="color:green;"><i class="fas fa-check-square"></i></span>
                        <span v-else style="color:grey;"><i class="far fa-check-square"></i></span>
                      </td>

                    </tr>
                    </tbody>
                  </table>
                </div>
              </div>
              <div class="row" v-if="editItem.id > 0 && user !== false && user.manageShopAccount === true" style="padding-bottom: 100px;">
                <div class="col-12 text-left section-header">
                  Merchant Users <button class="btn btn-primary right-button" v-on:click="addMerchantUser(editItem.id)"><i class="fas fa-plus"></i> Add</button>
                </div>
                <div class="col-12 border" style="min-height: 100px;">
                  <table class="table text-left">
                    <tr>
                      <th></th>
                      <th style="width:30%;">Name</th>
                      <th style="width:30%;">User ID/email</th>
                      <th style="width:20%;"></th>
                      <th style="width:20%;"></th>
                    </tr>
                    <tr v-for="(u, ui) in editItem.users">
                      <td>{{u.id}}</td>
                      <td>

                        <input v-if="u.edit" v-model="u.name" class="form-control under-bar-input"
                               @blur="u.edit = false; updateMerchantUser(ui)"
                               @keyup.enter="u.edit = false; updateMerchantUser(ui)"/>

                        <label v-if="u.edit == false" @click="u.edit=true;">{{u.name}}</label>
                      </td>
                      <td>
                        <input v-if="u.edit" v-model="u.email" class="form-control under-bar-input"
                               @blur="u.edit = false; updateMerchantUser(ui)"
                               @keyup.enter="u.edit = false; updateMerchantUser(ui)"/>

                        <label v-if="u.edit == false" @click="u.edit=true;">{{u.email}}</label>
                      </td>
                      <td>
                        <button class="btn btn-dark" v-on:click="resetPassword(u)">Rest Password</button>
                      </td>
                      <td>
                        <button class="btn btn-danger" v-on:click="askDeleteUser(u)"><i class="fas fa-trash"></i></button>
                      </td>
                    </tr>
                  </table>
                </div>

              </div>
            </div>
          </transition>
        </div>
      </div>
    </div>
    <div class="floating-button" style="bottom: 20px; left: 20px;" v-on:click="createNewMerchant" v-if="editItem == false || editItem.id > 0">
      <i class="fas fa-plus"></i>
    </div>
    <div class="floating-button" style="bottom: 20px; left: 100px;" v-on:click="downloadList" v-if="editItem == false || editItem.id > 0">
      <i class="fas fa-download"></i>
    </div>
    <input type="file" ref="file" style="display: none;" v-on:change="excelFilePickedUp"/>
    <div class="floating-button" style="bottom: 20px; left: 180px;" v-on:click="onFileSelectorClick" v-if="editItem == false || editItem.id > 0">

      <i class="fas fa-upload"></i>
    </div>
    <transition name="slideup">
      <div class="form-background" v-if="editUser != false">
        <div class="form-container">
          <div class="container">
            <div class="row">
              <div class="col-12 form-header">
                New Merchant User
              </div>
            </div>
            <div class="row form-item-container">
              <div class="col-12">
                <input type="text" class="form-control" v-model="editUser.email" placeholder="Email address or username"/>
              </div>
              <div class="col-12">
                <input type="text" class="form-control" v-model="editUser.name" placeholder="Name"/>
              </div>
              <div class="col-12">
                <input type="text" class="form-control" v-model="editUser.password" placeholder="Password"/>
              </div>
              <div class="col-12">
                <input type="text" class="form-control" v-model="editUser.password2" placeholder="Confirm Password"/>
              </div>
            </div>
            <div class="row" style="padding-top: 10px;">
              <div class="col-6">
                <button class="btn btn-secondary form-control" v-on:click="cancelNewMerchantUser">Cancel</button>
              </div>
              <div class="col-6">
                <button class="btn btn-primary form-control" v-on:click="addNewMerchantUser">Create</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </transition>
    <transition name="slideup">
      <div class="form-background" v-if="unpaidView != false">
        <div class="modal-wrapper" style="width: 90%;">
          <div class="modal-container">
            <div class="modal-header">
              <div class="container">
                <div class="row">
                  <div class="col-12" style="height: 50px; line-height: 50px; font-size: 1.2em;">
                    {{unpaidView.merchant.title}} Unpaid List
                  </div>
                </div>
                <div class="row">
                  <div class="col-12">
                    <select v-model="unpaidView.condition">
                      <option value="before">Before</option>
                      <option value="from">From</option>
                      <option value="between">Between</option>
                    </select>
                    From: <input type="date" v-model="unpaidView.from"/> <span v-if="unpaidView.condition === 'between'"> To: <input type="date" v-model="unpaidView.to"/></span>
                    <button class="btn btn-primary" v-on:click="getUnpaidList">GET</button>
                  </div>
                </div>
              </div>
            </div>
            <div class="modal-body">
              <div class="container">
                <div class="row">
                  <div class="col-12">
                    <table class="table" v-if="unpaidView.list.length > 0">
                      <tr>
                        <th>INV (ID)</th>
                        <th>Date</th>
                        <th>Due</th>
                        <th>Paid</th>
                        <th>Balance</th>
<!--                        <th>Payment</th>-->

                      </tr>
                      <tbody>
                      <tr v-for="order in unpaidView.list">
                        <td><span v-if="order.invoice != null" v-on:click="openInvoice(order)">{{order.invoice.title}}</span><span v-else>{{order.id}}</span></td>
                        <td><span v-if="order.delivered == false">{{order.deliveryDate}}</span><span v-else>{{order.deliveredDate}}</span></td>
                        <td><span v-if="order.orderType === 'credit'">-</span> £{{(order.finalDue/100.0).toFixed(2)}}</td>
                        <td><span v-if="order.orderType === 'credit'">-</span> £{{(order.paid/100.0).toFixed(2)}}</td>
                        <td><span v-if="order.orderType === 'credit'">-</span>£{{((order.finalDue-order.paid)/100.0).toFixed(2)}}</td>
<!--                        <td><input type="number" v-model="order.amountToPay"/></td>-->
<!--                        <td v-on:click="toggleUnpaidItem(order)" style="font-size: 20px;"><i class="fas" v-bind:class="{'fa-check unselected':order.selected == false, 'fa-check-circle selected':order.selected == true}"></i></td>-->
                      </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>

            <div class="modal-footer">
              <div class="container">
                <div class="row">
                  <div class="col-6 text-left">
                    <button class="btn btn-dark" v-on:click="unpaidView = false">Close</button>
                  </div>
                  <div class="col-6 text-right">
<!--                    <button class="btn btn-success" v-on:click="exportExcel('xlsx')"><i class="fas fa-file-excel"> Excel</i></button>-->
<!--                    <button class="btn btn-success" v-on:click="printStatement"><i class="fas fa-print"></i> Print</button>-->
<!--                    <button class="btn btn-primary" v-on:click="addNewAccount"><span><i class="fas fa-plu"></i></span> Add</button>-->
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </transition>
    <transition name="slideup">
      <div class="form-background" v-if="editItem != false && showAccounts != false">
        <div class="modal-wrapper" style="width: 90%;">
          <div class="modal-container">

            <div class="modal-header">
<!--              <div class="modal-header-1">-->

<!--              </div>-->
<!--              <div class="modal-header-2">-->
<!--                Edit Item-->
<!--              </div>-->

<!--              <div class="modal-header-3">-->

<!--              </div>-->
              <div class="container">
                <div class="row">
                  <div class="col-12" style="height: 50px; line-height: 50px; font-size: 1.2em;">
                    {{editItem.title}} Account
                  </div>
                </div>
                <div class="row">
                  <div class="col-12">
                    From: <input type="date" v-model="accountFilter.from"/> To: <input type="date" v-model="accountFilter.to"/>

                    <select v-model="accountFilter.type">
                      <option value="all">All</option>
                      <option value="unpaid">Unpaid</option>
                    </select>
                    <select v-model="accountFilter.condition" v-if="accountFilter.type === 'unpaid'">
                      <option value="before">Before</option>
                    </select>
                    <button class="btn btn-primary" v-on:click="getAccounts">GET</button>

                  </div>
                </div>
              </div>
            </div>
            <div class="modal-body">
              <div class="container" id="account-print-area" v-if="showAccounts == true">
                <div class="row show-for-print">
                  <div class="col-6 text-left">
                    <h4>{{editItem.title}} Statement</h4>
                  </div>
                  <div class="col-6 text-right">
                    <h4>{{accountFilter.from}} - {{accountFilter.to}}</h4>
                  </div>
                </div>
                <div class="row">
                  <div class="col-12 print-container">
                    <table class="table" id="account-table">
                      <tr class="sticky-header-row">
                        <th>Date</th>
                        <th>A/C Date</th>
                        <th>Type</th>
                        <th>REF No.</th>
                        <th>Net</th>
                        <th>VAT</th>
                        <th>Total</th>
                        <th>Payment</th>
                        <th>Balance</th>
                        <th class="hide-for-print"></th>
                      </tr>
                      <tr v-if="accounts.length > 0" v-for="account in accounts" v-bind:class="{'account-sale-item':account.debt > 0, 'account-credit-item': account.credit > 0 || account.credit < 0, 'account-payment-item': account.payment > 0}">
                        <td>{{dateString(account.createdTimestamp, '-')}}</td>
                        <td>{{account.accountDate}}</td>
                        <td>
                          <span v-if="account.debt > 0">SALES</span>
                          <span v-else-if="account.credit > 0">CREDIT</span>
                          <span v-else-if="account.credit < 0">CREDIT CANCEL</span>
                          <span v-else-if="account.payment > 0">PAYMENT</span>
                        </td>

                        <td>
                          <template v-if="account.list != null && account.list.length > 0">
                            <div v-for="ca in account.list" style="cursor: pointer;" v-if="ca.invoice != null"  v-on:click="openInvoice(ca)">{{ca.invoice.title}}</div>
                          </template>
                          <template v-else>
                            <span v-if="account.invoice != null" v-on:click="openInvoice(account)">{{account.invoice.title}}</span>
                          </template>
                        </td>
                        <td><span v-if="account.credit > 0">-</span>{{(account.net/100.0).toFixed(2)}}</td>
                        <td><span v-if="account.credit > 0">-</span>{{(account.tax/100.0).toFixed(2)}}</td>
                        <td>
                          <span v-if="account.credit != 0">{{((account.credit*-1)/100.00).toFixed(2)}}</span>
                          <span v-if="account.debt != 0">{{(account.debt/100.00).toFixed(2)}}</span>
                        </td>
                        <td>

                          <span v-if="account.payment != 0">{{(account.payment/100.00).toFixed(2)}}</span>
                        </td>
                        <td>{{(account.balance/100.00).toFixed(2)}}</td>
                        <td class="hide-for-print">
                          <span v-if="account.payment > 0 && account.list != null && account.list.length > 0" v-on:click="openPaymentView(account)"><i class="fas fa-info-circle"></i></span>
                          <span v-else-if="account.invoice != null" v-on:click="openInvoice(account)"><i class="fas fa-file"></i></span>
                          <span style="margin-left: 20px;" v-if="user.type === 'ROLE_ADMIN'" v-on:click="deleteAccountRecord(account.id)"><i class="fas fa-trash"></i></span>

                        </td>
                      </tr>
                    </table>
                  </div>
                </div>
              </div>
            </div>
            <div class="modal-footer">
              <div class="container">
                <div class="row">
                  <div class="col-6 text-left">
                    <button class="btn btn-dark" v-on:click="closeAccount">Close</button>
                  </div>
                  <div class="col-6 text-right">
                    <button class="btn btn-success" v-on:click="exportExcel('xlsx')"><i class="fas fa-file-excel"> Excel</i></button>
                    <button class="btn btn-success" v-on:click="printStatement"><i class="fas fa-print"></i> Print</button>
                    <button class="btn btn-primary" v-on:click="addNewAccount"><span><i class="fas fa-plu"></i></span> Add</button>
                  </div>
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>
    </transition>
    <transition name="slideup">
      <div class="form-background" v-if="editAccount != false">
        <div class="form-container" style="width:80%; max-width: 80%; height:80%; padding-top:10px; padding-bottom: 10px;">
          <div class="container" style="height: 30px; font-weight: bold;">
            Add Credit / Payment
          </div>
          <div class="container" style="height: 40px;">
            <div class="row">
              <div class="col-4">
                Date
                <input type="date" v-model="editAccount.accountDate" class="form-control" style="width: 200px; display: inline-flex;"/>
              </div>
              <div class="col-4">
                Type
                <select class="form-control" v-model="editAccount.type"  style="width: 200px; display: inline-flex;">
                  <option value="">Select</option>
                  <option value="Payment">Payment</option>
                  <option value="Credit">Credit</option>
                </select>
              </div>

              <div class="col-4">
                Amount
                <input class="form-control" v-model="editAccount.amount"  style="width: 200px; display: inline-flex; text-align: right;"/>
              </div>
            </div>
          </div>
          <div class="container" style="height: calc(100% - 100px); overflow-y: auto;">
            <div class="row">
              <div class="col-12">
                <table class="table">
                  <tr>
                    <th>INV (ID)</th>
                    <th>Date</th>
                    <th>Due</th>
                    <th>Balance</th>
                    <th>Payment</th>
                    <th></th>
                  </tr>
                  <tbody>
                  <tr v-for="order in unpaidList">
                    <td><span v-if="order.invoice != null" v-on:click="openInvoice(order)">{{order.invoice.title}}</span><span v-else>{{order.id}}</span></td>
                    <td><span v-if="order.delivered == false">{{order.deliveryDate}}</span><span v-else>{{order.deliveredDate}}</span></td>
                    <td><span v-if="order.orderType === 'credit'">-</span> £{{(order.finalDue/100.0).toFixed(2)}}</td>
                    <td><span v-if="order.orderType === 'credit'">-</span>£{{((order.finalDue-order.paid)/100.0).toFixed(2)}}</td>
                    <td><input type="number" v-model="order.amountToPay" v-on:change="paymentAmountEntered(order)"/></td>
                    <td v-on:click="toggleUnpaidItem(order)" style="font-size: 20px;"><i class="fas" v-bind:class="{'fa-check unselected':order.selected == false, 'fa-check-circle selected':order.selected == true}"></i></td>
                  </tr>
                  </tbody>
                </table>
<!--                <select class="form-control" v-model="editAccount.orderId">-->
<!--                  <option value="0">Select Order</option>-->
<!--                  <option v-for="order in unpaidList" :value="order.id"><strong>#{{order.id}} ({{order.deliveryDate}})</strong> Due:£{{(order.finalDue/100.0).toFixed(2)}} Balance:£{{((order.finalDue-order.paid)/100.0).toFixed(2)}}</option>-->
<!--                </select>-->
              </div>
            </div>
          </div>

          <div class="container" style="height: 30px; line-height: 30px;">
            <div class="row" style="height: 30px; line-height: 30px;">
              <div class="col-6" style="height: 30px; line-height: 30px;">
                <button class="btn btn-dark form-control" v-on:click="cancelNewAccount">Close</button>
              </div>
              <div class="col-6" style="height: 30px; line-height: 30px;">
                <button class="btn btn-primary form-control" v-on:click="submitNewAccount">Submit</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </transition>
    <transition name="slideup">
      <div class="item-container" v-if="paymentView != false" v-on:click="paymentView = false">
        <div style="position: absolute; width: 80%; height: 95%; top:50%; left:50%; transform: translate(-50%, -50%); background-color: white; border-radius: 10px; box-shadow: 5px 5px 20px black;" v-on:click.stop="dummy">
          <div style="width:800px; height:100%; padding-top:10px; margin:auto">
            <table class="table">

              <tr class="sticky-header-row">
                <th>Date</th>
                <th>REF No.</th>
                <th>Payment</th>
                <th></th>
              </tr>
              <tbody v-if="paymentView.list == null || paymentView.list.length == 0">
                <tr >
                  <td>{{dateString(paymentView.createdTimestamp, '-')}}</td>
                  <td>
                    <span v-if="paymentView.invoice != null" v-on:click="openInvoice(paymentView)">{{paymentView.invoice.title}}</span>
                  </td>
                  <td>
                    <span>{{(paymentView.payment/100.00).toFixed(2)}}</span>
                  </td>
                  <td class="hide-for-print"><span v-if="paymentView.invoice != null" v-on:click="openInvoice(paymentView)"><i class="fas fa-file"></i></span></td>
                </tr>
              </tbody>
              <tbody v-else-if="paymentView.list != null && paymentView.list.length > 0">
                <tr v-for="account in paymentView.list">
                  <td>{{dateString(account.createdTimestamp, '-')}}</td>
                  <td>
                    <span v-if="account.invoice != null" v-on:click="openInvoice(account)">{{account.invoice.title}}</span>
                  </td>
                  <td>
                    <span>{{(account.payment/100.00).toFixed(2)}}</span>
                  </td>
                  <td class="hide-for-print"><span v-if="account.invoice != null" v-on:click="openInvoice(account)"><i class="fas fa-file"></i></span></td>
                </tr>
                <tr style="font-weight: bold;">
                  <td>{{dateString(paymentView.createdTimestamp, '-')}}</td>
                  <td>

                  </td>
                  <td>
                    <span>{{(paymentView.payment/100.00).toFixed(2)}}</span>
                  </td>
                  <td class="hide-for-print"></td>
                </tr>
              </tbody>
            </table>
          </div>

        </div>
      </div>
    </transition>
    <transition name="slideup">
      <div class="item-container" v-if="invoiceView != false" v-on:click="closeInvoiceView()">
        <div style="position: absolute; width: 80%; height: 95%; top:50%; left:50%; transform: translate(-50%, -50%); background-color: white; border-radius: 10px; box-shadow: 5px 5px 20px black;" v-on:click.stop="dummy">
          <div style="width:800px; height:100%; padding-top:10px; margin:auto;">
            <embed :src="'https://storage.googleapis.com/kokoro-294123.appspot.com/' + invoiceView.invoice.description" style="width: 90%; height: calc(100% - 20px); margin:auto"/>
          </div>

        </div>
      </div>
    </transition>
    <div class="manual-button" style="bottom: 20px; right: 40px; background: #000;" v-on:click="openManual">
      <i class="fas fa-question-circle"></i>
    </div>
    <div v-if="merchantProductView !== false" style="position: fixed; top:0; left: 0; width: 100%; height: 100%; background-color: rgba(0,0,0,0.5);">
      <div style="position: absolute; top: 50%; left: 50%; width: 1500px; height: calc(100% - 50px); transform: translate(-50%, -50%); background-color: white;">
        <merchant-product-view
          :merchant="merchantProductView.merchant"
          :on-close="onCloseMerchantProductView"></merchant-product-view>
      </div>
    </div>
  </div>
</template>

<script>

import {
  getMerchants,
  updateMerchant,
  createNewMerchant,
  createNewMerchantUser,
  getMerchant,
  updateDeliveryDate, getMerchantReport, updateMerchantBulk, deleteMerchant, activateMerchant, enableMerchantAPI
} from "../api/merchant";
import {updateUser, getMerchantUserList, deleteUser, resetUser, getUserByToken, getDriverList} from "../api/user";
import {
  getDateString,
  getDayEnd,
  getDayStart, getShiftList,
  millisToDate,
  millisToReadable,
  setLastPage,
  showDialog
} from "../api/utils";
    import EventBus from "../api/event-bus";
  import {deleteAccount, getMerchantAccounts, submitNewAccount} from "../api/account";
  import {getUnpaidOrder} from "../api/order";
  import {getVendorReport} from "../api/vendors";
  import {updateProductBulk} from "../api/product";
  import InputTag from 'vue-input-tag'
  import MerchantProductView from "./MerchantProductView";

    export default {
      name: "Merchants",
      data() {
          return {
            merchants:[],
            editItem:false,
            editUser:false,
            merchantType:'all',
            accounts:false,
            showAccounts: false,
            accountFilter: {
              from:'',
              to:'',
              type:'all',
              condition:'before'
            },
            editAccount:false,
            unpaidList:[],
            state: {
              tickets: [{name: "test"}],
              headers: ["Test header"]
            },
            invoiceView:false,
            paymentView: false,
            user: false,
            merchantProductView: false,
            merchantSearch:'',
            unpaidView: false,
            drivers:[],
            shiftList:getShiftList(),
          }
      },
      components: {
        InputTag,
        MerchantProductView
      },
      created() {
        setLastPage(this.$route.path);
        this.updateView();
      },
      mounted() {
        this.getMyInfo();
      },
      methods: {
        dummy: function() {

        },
        pad: function(n, width, z) {
          z = z || '0';
          n = n + '';
          return n.length >= width ? n : new Array(width - n.length + 1).join(z) + n;
        },
        timeString: millisToReadable,
        dateString:millisToDate,
        getDayString: function(day) {
          if(day == 0) {
            return 'Sunday';
          } else if(day == 1) {
            return 'Monday';
          } else if(day == 2) {
            return 'Tuesday';
          } else if(day == 3) {
            return 'Wednesday';
          } else if(day == 4) {
            return 'Thursday';
          } else if(day == 5) {
            return 'Friday';
          } else if(day == 6) {
            return 'Saturday';
          }
          return 'Unknown (' + day + ')';
        },
        getMyInfo: function() {
          let self = this;
          getUserByToken()
            .then(function(data) {
              self.$data.user = data;
              // console.log("user acquired");
              // console.log(self.$data.user);

              self.getDriverList();
            })
            .catch(function(err) {

            })
        },
        getShiftName: function(val) {
          for(let i = 0 ; i < this.$data.shiftList.length ; i++) {
            if(this.$data.shiftList[i].value === val) {
              return this.$data.shiftList[i].title;
            }
          }
          return '(' + val + ')';
        },
        getDriverName: function(id) {
          for(let i = 0 ; i < this.$data.drivers.length ; i++) {
            if(this.$data.drivers[i].id === id) {
              return this.$data.drivers[i].name;
            }
          }
          return 'Unknown ('+id +')';
        },
        getDriverList: function() {
          let self = this;
          getDriverList()
            .then(function(data) {
              if(data.success === true) {
                self.$data.drivers = data.item;
              } else {
                showDialog("Driver가 없습니다.")
              }
            })
            .catch(function(err) {

            })
        },
        updateView: function() {
          let self = this;
          console.log("Get Vendor List")
          getMerchants()
          .then(function(data) {
            if(data.success == true) {
              let deactivatedList = [];
              for(let i = 0 ; i < data.item.length ; i++) {
                if(data.item[i].active === true) {
                  self.$data.merchants.push(data.item[i]);
                } else {
                  deactivatedList.push(data.item[i]);
                  console.log(data.item[i].title + ' is ' + data.item[i].active);
                }
              }
              if(deactivatedList.length > 0) {
                for(let i = 0 ; i < deactivatedList.length ; i++) {
                  self.$data.merchants.push(deactivatedList[i]);
                }

              }


            }
          })
          .catch(function(err) {
            console.log(err);
          })
        },
        getTotalBalance: function() {
          if(this.$data.merchants === null || this.$data.merchants.length === 0) {
            return '';
          }
          let total = 0;
          for(let i = 0 ; i < this.$data.merchants.length ; i++) {
            if(this.$data.merchantType === 'all' || this.$data.merchantType === this.$data.merchants[i].type) {
              total += parseInt(this.$data.merchants[i].accountBalance);
            }
          }
          if(total > 0) {
            return '<br/>' + (total/100.0).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",");
          }
          return '';
        },
        createNewMerchant: function() {
          this.$data.editItem = createNewMerchant();
          this.$data.editItem.edit = true;
        },
        editMerchantItem: function() {
          this.$data.editItem.edit = true;
        },
        // cancelEditMerchant: function() {
        //   let self = this;
        //   getMerchant(this.$data.editItem.id)
        //     .then(function(data) {
        //       if(data.success == true) {
        //         self.$data.editItem = data.item;
        //         self.$data.editItem.edit = false;
        //         self.$data.editItem.users = [];
        //         self.getMerchantUserList(self.$data.editItem.id);
        //       } else {
        //         showDialog("Failed to get Shop " + data.message);
        //       }
        //     })
        //     .catch(function(err) {
        //       showDialog("Error " + err, "Error");
        //     })
        // },
        askDeleteMerchant: function(item) {
          let self = this;

          let question = 'Deactivate';
          if(item.active === false) {
            question = 'Activate';
          }
          this.$modal.show('dialog', {
            title:'',
            text: 'Are you sure to ' + question + ' ' + item.title + "?",
            buttons:[
              {
                title:'No',
                handler:()=>{
                  self.$modal.hide('dialog');
                }
              },
              {
                title:'Yes ' + question,
                handler:()=>{
                  self.$modal.hide('dialog');
                  self.deleteMerchant(item);
                }
              }
            ]
          })
        },
        deleteMerchant: function(item) {
          let self = this;
          activateMerchant(item.id, !item.active)
          .then(function(data) {
            if(data.success == true) {
              self.$data.editItem = false;
              for(let i = 0 ; i < self.$data.merchants.length ; i++) {
                if(self.$data.merchants[i].id == data.item.id) {
                  self.$data.merchants.splice(i, 1);
                  return;
                }
              }
            } else {
              showDialog(data.message);
            }
          })
          .catch(function(err) {
            let msg = err;
            if(err.response != undefined) {
              msg += ' (' + err.response + ')';
            }
            showDialog(msg, "ERROR");
          })
        },
        enableApi: function(item, enable) {
          let self = this;
          enableMerchantAPI(item.id, enable)
            .then(function(data) {
              if(data.success === true) {
                for(let i = 0 ; i < self.$data.merchants.length ; i++) {
                  if(self.$data.merchants[i].id == data.item.id) {
                    self.$data.merchants.splice(i, 1, data.item);
                    break;
                  }
                }
                //
                self.openItem(data.item);
              } else {
                showDialog(data.message);
              }
            })
            .catch(function(err) {
              console.log(err);
              let msg = err;
              if(err.response !== undefined) {
                console.log(err.response);
                msg += ' (' + err.response + ')';
              }
              showDialog(msg, "ERROR");
            })
        },
        saveItem: function() {
          let self = this;
          console.log("save merchant item");
          console.log(this.$data.editItem);
          updateMerchant(this.$data.editItem)
          .then(function(data) {
            if(data.success == true) {
              for(let i = 0 ; i < self.$data.merchants.length ; i++) {
                if(self.$data.merchants[i].id == data.item.id) {
                  self.$data.merchants.splice(i, 1, data.item);
                  self.$data.editItem = false;
                  return;
                }
              }
              self.$data.merchants.push(data.item);
              self.$data.editItem = false;
            } else {
              console.log(data.message);
            }
          })
          .catch(function(err) {

          })
        },
        openItem: function(item) {
          // this.$data.editItem.users = [];
          if(this.$data.editItem != false) {
            this.$data.editItem = false;
            let self = this;
            setTimeout(function(){self.openItem(item)}, 300);
            return;
          }
          let self = this;
          getMerchant(item.id)
          .then(function(data) {
            if(data.success == true) {
              self.$data.editItem = data.item;
              self.$data.editItem.edit = false;
              self.$data.editItem.users = [];
              self.getMerchantUserList(self.$data.editItem.id);
            } else {
              showDialog("Failed to get Shop " + data.message);
            }
          })
          .catch(function(err) {
            showDialog("Error " + err, "Error");
          })
          // this.$data.editItem = JSON.parse(JSON.stringify(item));
          // this.$data.editItem.users = [];
          // this.getMerchantUserList(this.$data.editItem.id);
        },

        getMerchantUserList: function(merchantId) {
          let self = this;
          getMerchantUserList(merchantId)
          .then(function(data) {
            if(data.success == true) {
              if(self.$data.editItem != false && self.$data.editItem.id == merchantId) {
                self.$data.editItem.users = data.item;
              }
            } else {
              console.log("Failed to get merchant user list " + data.message);
            }
          })
          .catch(function(err) {

          })
        },
        addMerchantUser: function(merchantId) {
          this.$data.editUser = createNewMerchantUser(merchantId);
        },
        cancelNewMerchantUser: function() {
          this.$data.editUser = false;
        },
        addNewMerchantUser: function() {
          if(this.$data.editUser.email.length < 5) {
            // window.alert("Email Address Required");
            showDialog('Email Required');
            return;
          }
          if(this.$data.editUser.password.length < 4) {
            showDialog('Password should be at least 4 characters');
            return;
          }
          if(this.$data.editUser.password !== this.$data.editUser.password2) {
            showDialog('Passwords are not matching');
            return;
          }

          let self = this;
          updateUser(this.$data.editUser)
          .then(function(data) {
            if(data.success == true) {

              if(data.item.merchantId == self.$data.editItem.id) {
                self.$data.editUser = false;
                self.$data.editItem.users.push(data.item);

              }
            } else {
              window.alert(data.message);
            }
          })
          .catch(function(err) {

          })
        },
        updateMerchantUser: function(index) {
          if(index >= this.$data.editItem.users.length) {
            window.alert("Something is wrong");
            return;
          }
        },
        checkDeliveryDay: function(index, key) {
          if(this.$data.user === false || this.$data.user.manageShopAccount === false) {
            showDialog("You do not have permission");
            return;
          }
          this.$data.editItem.deliveryDates[index][key] = !this.$data.editItem.deliveryDates[index][key];
          this.updateDeliveryDateItem(index)
        },
        updateDeliveryDateItem: function(index) {
          updateDeliveryDate(this.$data.editItem.deliveryDates[index])
          .then(function(data) {
            if(data.success == true) {

            } else {
              showDialog(data.message);
            }
          })
          .catch(function(err) {
            let msg = err;
            if(err.response != undefined) {
              msg += " (" + err.response + ')';
            }
            showDialog(msg);
          })
        },

        closeAccount: function() {
          this.$data.accounts = false;
          this.$data.showAccounts = false;
        },
        openAccounts: function() {
          this.$data.accountFilter.from = getDateString(new Date().getTime(), -30);
          this.$data.accountFilter.to = getDateString(new Date().getTime(), 0);
          this.getAccounts();
        },
        getAccounts: function() {
          console.log("get accounts from " + this.$data.accountFilter.from + " to " + this.$data.accountFilter.to);
          let from = getDayStart(this.$data.accountFilter.from);
          let to = getDayEnd(this.$data.accountFilter.to);
          this.$data.accounts = [];
          this.$data.showAccounts = true;
          let self = this;
          getMerchantAccounts(this.$data.editItem.id, from, to)
          .then(function(data) {
            if(data.success == true) {
              console.log("account list");
              console.log(data.list);
              self.$data.accounts = data.list;
            } else {
              // showDialog(data.message);
            }
          })
          .catch(function(err) {
            let msg = err;
            if(err.response != undefined) {
              msg += ' (' + err.message + ')';
            }
            showDialog(msg);
          })
        },
        openUnpaidList: function(merchant) {
          this.$data.unpaidView = {
            merchant: merchant,
            from:'',
            to:'',
            condition:'before',
            list:[],
          }
        },
        getUnpaidList: function() {
          console.log("get unpaid");
          let from = getDayStart(this.$data.unpaidView.from);
          // let to = getDayEnd(this.$data.unpaidView.to);
          this.$data.unpaidView.list = [];
          let self = this;
          let query = "condition=" + this.$data.unpaidView.condition + "&from=" + from;
          getUnpaidOrder(this.$data.unpaidView.merchant.id, query)
            .then(function(data) {
              if(data.success == true) {
                console.log("unpaid list");
                console.log(data.item);
                self.$data.unpaidView.list = data.item;
              } else {
                showDialog(data.message);
              }
            })
            .catch(function(err) {
              let msg = err;
              if(err.response != undefined) {
                msg += ' (' + err.message + ')';
              }
              showDialog(msg);
            })
        },
        cancelEditMerchant: function() {
          let self = this;
          getMerchant(this.$data.editItem.id)
            .then(function(data) {
              if(data.success == true) {
                self.$data.editItem = data.item;
                self.$data.editItem.edit = false;
                self.$data.editItem.users = [];
                self.getMerchantUserList(self.$data.editItem.id);
              } else {
                showDialog("Failed to get Shop " + data.message);
              }
            })
            .catch(function(err) {
              showDialog("Error " + err, "Error");
            })
        },
        resetPassword: function(item) {
          let self = this;
          this.$modal.show('dialog', {
            title:'',
            text: '사용자 ' +  item.email + " " + item.name+  " 비밀번호를 리셑 하시겠습니까?",
            buttons:[
              {
                title:'아니오',
                handler:()=>{
                  self.$modal.hide('dialog');
                }
              },
              {
                title:'리셑하기',
                handler:()=>{
                  self.$modal.hide('dialog');
                  self.resetPasswordConfirmed(item);
                }
              }
            ]
          })
        },
        resetPasswordConfirmed: function(item) {
          let user = JSON.parse(JSON.stringify(item));
          user.password = 'kokoro1234';
          let self = this;
          updateUser(user)
          .then(function(data) {
            if(data.success == true) {
              showDialog("Password Successfully reset to kokoro1234");
              for(let i = 0 ; i < self.$data.editItem.users.length ; i++) {
                if(self.$data.editItem.users[i].id == data.item.id) {
                  self.$data.editItem.splice(i, 1, data.item);
                }
              }
            } else {
              showDialog(data.message);
            }
          })
          .catch(function(err) {
            let msg = err;
            if(err.response != undefined) {
              msg += ' (' + err.response + ')';
            }
            showDialog(msg);
          })
        },
        askDeleteUser: function(item) {
          let self = this;
          this.$modal.show('dialog', {
            title:'',
            text: '사용자 ' +  item.email + " " + item.name+  " 삭제 하시겠습니까?",
            buttons:[
              {
                title:'아니오',
                handler:()=>{
                  self.$modal.hide('dialog');
                }
              },
              {
                title:'삭제하기',
                handler:()=>{
                  self.$modal.hide('dialog');
                  self.deleteUser(item);
                }
              }
            ]
          })
        },
        deleteUser: function(item) {
          let self = this;
          deleteUser(item.id)
          .then(function(data) {
            if(data.success == true) {
              // self.$data.editItem = false;
              for(let i = 0 ; i < self.$data.editItem.users.length ; i++) {
                if(self.$data.editItem.users[i].id == data.item.id) {
                  self.$data.editItem.users.splice(i, 1);
                  return;
                }
              }
            } else {
              showDialog(data.message);
            }
          })
          .catch(function(err) {
            let msg = err;
            if(err.response != undefined) {
              msg += ' (' + err.response + ')';
            }
            showDialog(msg, "ERROR");
          })
        },
        addNewAccount: function() {
          this.$data.editAccount = {
            id:0,
            merchantId:this.$data.editItem.id,
            type:'Payment',
            amount:0,
            description:'',
            orderId:0,
            accountDate:millisToDate(new Date().getTime(), '-'),
          }
          console.log("show add account");
          this.populateUnpaidList();
        },
        deleteAccountRecord: function(id) {
          let self = this;
          this.$modal.show('dialog',{
            title: "DELETE ACCOUNT RECORD",
            text: "The record will be permanently deleted. All records will be updated after deletion. Proceed deletion?",
            buttons:[
              {title:'Close'},
              {
                title:'DELETE',
                handler:() => {
                  self.$modal.hide('dialog');
                  self.confirmDeleteAccountRecord(id);
                }
              }
            ]
          })

        },
        confirmDeleteAccountRecord: function(id) {
          let self = this;
          deleteAccount(id)
          .then(function(data) {
            if(data.success === true) {
              showDialog(data.message);
              self.getAccounts();
            } else {
              showDialog(data.message);
            }
          })
          .catch(function(err) {
            let msg = err;
            if(err.response !== undefined) {
              msg += ' (' + err.response + ')';
            }
            showDialog(msg, "ERROR");
          })
        },
        cancelNewAccount: function() {
          this.$data.editAccount = false;
        },
        submitNewAccount: function() {
          if(this.$data.editAccount.amount == 0) {
            showDialog("Please enter amount");
            return;
          }

          if(this.$data.editAccount.type == 'Payment') {
            this.$data.editAccount.payment = Math.round(Number(this.$data.editAccount.amount) * 100);
            // if(this.$data.editAccount.orderId == 0) {
            //   showDialog("Please select order");
            //   return;
            // }
          } else if(this.$data.editAccount.type == 'Credit') {
            this.$data.editAccount.credit = Math.round(Number(this.$data.editAccount.amount) * 100);
          } else {
            showDialog("Please select type");
            return;
          }

          let list = [];
          for(let i = 0 ; i < this.$data.unpaidList.length ; i++) {
            if(this.$data.unpaidList[i].selected == true) {
              let ac = {
                id:0,
                payment:Math.round(Number(parseFloat(this.$data.unpaidList[i].amountToPay)*100)),
                orderId:this.$data.unpaidList[i].id,
                accountDate:this.$data.editAccount.accountDate,
                merchantId:this.$data.unpaidList[i].merchantId,
              }
              list.push(ac);
            } else if(Math.round(Number(parseFloat(this.$data.unpaidList[i].amountToPay)*100) !== 0)) {
              showDialog(this.$data.unpaidList[i].invoice.title + " payment amount is not zero but not selected. Please tick the check icon or change amount to 0");
              return;
            }
          }
          if(list.length  == 0) {
            showDialog("Please select order for payment");
            return;
          }

          let item = this.$data.editAccount;

          if(list.length == 1) {
            item = list[0];
          } else if(list.length > 1) {
            item.list = list;
          }


          let self = this;
          submitNewAccount(item)
          .then(function(data) {
            if(data.success) {
              self.$data.editAccount = false;
              self.updateView();
              self.getAccounts();
            } else {
              showDialog(data.message, "Failed")
            }
          })
          .catch(function(err) {
            let msg = err;
            if(err.response != undefined) {
              msg += ' (' + err.response + ')';
            }
            showDialog("Error " + msg, "OOPS");
          })
        },
        populateUnpaidList: function() {
          this.$data.unpaidList = [];
          let self = this;
          getUnpaidOrder(this.$data.editItem.id)
          .then(function(data) {
            console.log(data);
            if(data.success == true) {
              for(let i = 0 ; i < data.item.length ; i++) {
                data.item[i].amountToPay = 0;
                data.item[i].selected = false;
              }
              self.$data.unpaidList = data.item;
            } else {
              showDialog(data.message);
            }
          })
          .catch(function(err) {
            let msg = err;
            if(err.response != undefined) {
              msg += ' (' + err.response + ')';
            }
            showDialog("Error " + msg, "OOPS");
          })
        },
        updateBulk:function(list) {
          if(list == undefined && list == null || list.length == 0) {
            return;
          }

          let self = this;
          updateMerchantBulk(list)

            .then(function(data) {
              if(data.success == true) {
                self.$data.merchants = [];
                self.updateView();
              } else {
                showDialog("Failed to update products " + data.message);
              }
            })
            .catch(function(err) {
              let msg = err;
              if(err.response != undefined) {
                msg += ' (' + err.response + ')';
              }
              showDialog(msg, "ERROR");
            })
        },
        downloadList: function() {
          const FileDownload = require('js-file-download');
          getMerchantReport()
            .then(function(response) {
              FileDownload(response.data, "Kokoro-Merchant-List-report.xlsx");
            })
            .catch(function(err) {
              console.log("report error " + err);
              if(err.response != undefined) {
                console.log(err.response);
              }
            })
        },
        onFileSelectorClick: function() {
          console.log("upload clicked");
          this.$refs.file.value = "";
          this.$refs.file.click();
        },
        excelFilePickedUp(e) {
          let self = this;
          if(e.target != undefined) {
            if (e.target.files != undefined) {
              console.log("PATH: " + e.target.files[0].name);
              let droppedFiles = e.target.files;

              ([...droppedFiles]).forEach(f => {
                if(f == undefined) {
                  return;
                }
                var reader = new FileReader(),
                  name = f.name;

                reader.onload = function (e) {
                  var results;
                  var data = e.target.result;


                  var fixedData = self.fixdata(data),
                    workbook = XLSX.read(btoa(fixedData), {type: 'base64'}),
                    firstSheetName = workbook.SheetNames[0],
                    worksheet = workbook.Sheets[firstSheetName];
                  self.$data.state.headers = self.get_header_row(worksheet);
                  results = XLSX.utils.sheet_to_json(worksheet, {range: 0, defval: ""});
                  console.log(results);
                  if(results.length < 3) {
                    window.alert("No Menu Data");
                    return;
                  }

                  let list = [];
                  for(let i = 0 ; i < results.length ; i++) {
                    let r = results[i];

                    if(r["Name"] === undefined || r["Name"] === "") {
                      continue;
                    }

                    let merchant = {
                      id:r["ID"],
                      title:r["Name"],
                      companyName:r["Company Name"],
                      companyNumber:r["Company Number"],
                      vatNumber:r["VAT Number"],
                      contactName:r["Responsible"],
                      contact:r["Contact"],
                      // email:r["Email"],
                      emails:[],
                      ccEmails:[],
                      postCode:r["Post Code"],
                      address:r["Address"],
                      type:r["Type"],
                    }
                    if(r["Emails"] !== undefined && r["Emails"].length > 0) {
                      merchant.emails = r["Emails"].split(",");
                    }
                    if(r["CC Emails"] !== undefined && r["CC Emails"].length > 0) {
                      merchant.ccEmails = r["CC Emails"].split(",");
                    }
                    list.push(merchant);



                  }

                  if(list.length > 0) {
                    self.updateBulk(list);
                  }
                }
                reader.readAsArrayBuffer(f);
              })


            }
          }
        },
        get_header_row: function (sheet) {
          var headers = [], range = XLSX.utils.decode_range(sheet['!ref']);
          //range.s.r = 2;//XLSX.utils.decode_row("3");
          var C, R = range.s.r; /* start in the first row */
          for (C = range.s.c; C <= range.e.c; ++C) { /* walk every column in the range */
            var cell = sheet[XLSX.utils.encode_cell({c: C, r: R})] /* find the cell in the first row */
            var hdr = "UNKNOWN " + C; // <-- replace with your desired default
            if (cell && cell.t) hdr = XLSX.utils.format_cell(cell);
            headers.push(hdr);
          }
          return headers;
        },
        fixdata: function (data) {
          var o = "", l = 0, w = 10240;
          for (; l < data.byteLength / w; ++l) o += String.fromCharCode.apply(null, new Uint8Array(data.slice(l * w, l * w + w)));
          o += String.fromCharCode.apply(null, new Uint8Array(data.slice(l * w)));
          return o;
        },
        openManual: function() {
          let url = "https://sites.google.com/boriumstudio.com/kokoro-erp-manual/shop-account";
          window.open(url, '_blank');
        },
        paymentAmountEntered: function(item) {
          if(item.amountToPay === null || item.amountToPay === '') {
            item.amountToPay = 0;
          }
          if(Math.round(parseFloat(item.amountToPay)*100) !== 0) {
            item.selected = true;
          } else {
            item.selected = false
          }
          let totalAmount = 0;
          for(let i = 0 ; i < this.$data.unpaidList.length ; i++) {
            totalAmount += parseFloat(this.$data.unpaidList[i].amountToPay);
          }
          this.$data.editAccount.amount = totalAmount.toFixed(2);
        },
        toggleUnpaidItem: function(item) {
          if(item != null) {
            item.selected = !item.selected;
            if(item.selected == true) {
              item.amountToPay = ((item.finalDue-item.paid)/100.0).toFixed(2);
              if(item.orderType === 'credit') {
                item.amountToPay *= -1;
              }
            } else {
              item.amountToPay = 0.00;
            }
          }

          let totalAmount = 0;
          for(let i = 0 ; i < this.$data.unpaidList.length ; i++) {
            totalAmount += parseFloat(this.$data.unpaidList[i].amountToPay);
          }
          this.$data.editAccount.amount = totalAmount.toFixed(2);
        },
        printStatement: function() {
          let self = this;
          this.$htmlToPaper('account-print-area', ()=>{
            console.log("Printing completed or was cancelled");


          });
        },
        exportExcel: function(type, fn, dl) {
          var elt = document.getElementById('account-table');
          var wb = XLSX.utils.table_to_book(elt, {sheet:"Sheet JS"});
          return dl ?
            XLSX.write(wb, {bookType:type, bookSST:true, type: 'base64'}) :
            XLSX.writeFile(wb, fn || (this.editItem.title+'-Statement.' + (type || 'xlsx')));
        },
        closeInvoiceView: function() {
          this.$data.invoiceView = false;
        },
        openInvoice: function(item) {
          this.$data.invoiceView = item;
        },
        openPaymentView: function(item) {
          this.$data.paymentView = item;
        },
        openMerchantProductView: function(merchant) {
          this.$data.merchantProductView = {
            merchant: merchant,
          }

        },
        onCloseMerchantProductView: function() {
          this.$data.merchantProductView = false;
        }
      }
    }
</script>

<style scoped>
.unselected {
  color: grey;
}
  .selected {
    color:green;
  }


tr.deactive {
  background-color: #FF8E8E;
}
</style>



// WEBPACK FOOTER //
// src/components/Merchants.vue